import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { Navigation, Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import 'swiper/swiper-bundle.css'
import { useTranslation } from 'react-i18next'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { useNavigate } from 'react-router-dom'

import img1 from 'resources/images/insurance1.jpg'
import img2 from 'resources/images/kxRisk.jpg'
import img3 from 'resources/images/risk.jpg'

import img4 from 'resources/images/services.webp'
import getLocalizedPath from 'utils/localizedPath'
export default function Services() {
    const [swiper, setSwiper] = useState(null)
    const [slideIndex, setSlideIndex] = useState(0)
    const {
        t,
        i18n: { language },
    } = useTranslation()
    const navigate = useNavigate()
    const servicesPath = getLocalizedPath('/our-services', language)
    const list = [
        {
            img: img1,
            title: 'services.trade.desc',
            // description: "services.trade.desc",
        },
        {
            img: img2,
            title: 'services.trade.desc2',
            // description: "services.desc2",
        },
        // {
        //   img: img3,
        //   title: "services.insuranceTitle",
        //   description: "services.insuranceDescription",
        // },
        // {
        //   img: img4,
        //   title: "services.servicesTitle",
        //   description: "services.servicesDescription",
        // },
    ]
    return (
        <div className='py-8 md:py-12 bg-container'>
            <div className='flex justify-between pb-10 items-center'>
                <h2 className='text-[#333d47] font-bold  text-2xl md:text-3xl lg:text-4xl '>{t('home.ourServices')}</h2>
                <div
                    onClick={() => navigate(servicesPath)}
                    className='cursor-pointer flex text-2xl font-semibold items-center gap-4 hover:opacity-70'
                >
                    <div className='whitespace-nowrap font-semiboldFamily'>{t('home.seeMore')}</div>
                    <ArrowForwardIcon />
                </div>
            </div>
            <Swiper
                loop={true}
                modules={[Navigation, Pagination]}
                pagination={{
                    clickable: true,
                }}
                spaceBetween={50}
                slidesPerView={4}
                onSwiper={(swiper) => {
                    setSwiper(swiper)
                }}
                onActiveIndexChange={(swiper) => {
                    setSlideIndex(swiper.realIndex)
                }}
                initialSlide={0}
                breakpoints={{
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    // 1440: {
                    //   slidesPerView: 4,
                    //   spaceBetween: 24,
                    // },
                }}
            >
                {list.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div
                            onClick={() => navigate(servicesPath)}
                            className='h-full cursor-pointer text-black bg-white group flex flex-col gap-4 pb-10'
                        >
                            <div className='w-full aspect-video rounded-[10px] relative overflow-hidden'>
                                <img src={item.img} className='w-full h-full object-cover' alt={t(item.title)} />
                                <div className='absolute bottom-0 z-40 left-0 w-0 h-[6px] bg-primaryRed-ktRed transition-all duration-500 ease-in-out group-hover:w-full'></div>
                            </div>
                            {/* <h3 className=" font-semibold text-xl px-4">{t(item.title)}</h3> */}
                            <p className='text-lg font-medium px-4'>{t(item.title)}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}
